module.exports = __webpack_public_path__ + "static/innovate-7120fb05a2a104fda52a0fa86bcee73e.gif";